import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppLayoutModule } from "../layout/app-layout.module";
import { DashboardRoutingModule } from "./dashboard.routing.module";
import { WidgetModule } from "../widget/widget.module";
import { MatComponentsModule } from "../../mat-components.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkDisplayComponent } from "./work-display-component/work-display.component";
import { AgGridModule } from "ag-grid-angular";
import { TopnavComponent } from "./topnav/topnav.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DashboardComponent } from "./dashboard.component";
import { PagesComponent } from "./pages/pages.component";
import { DpmStaticComponent } from "./static/dpm-static/dpm-static.component";
import { DemStaticComponent } from "./static/dem-static/dem-static.component";
import { SqlCacheStaticComponent } from "./static/sql-cache-static/sql-cache-static.component";
import { VisitPlannerStaticComponent } from "./static/visit-planner-static/visit-planner-static.component";
import { MarketAccessMoonlakeComponent } from "./static/market-access-moonlake/market-access-moonlake.component";
import { MoonlakeWaterfallChartComponent } from "./static/market-access-moonlake/moonlake-waterfall-chart.component";
import { MoonlakeSeriesChartComponent } from "./static/market-access-moonlake/moonlake-series-chart.component";
import { StaticDashboardHostComponent } from "./static/static-dashboard-host/static-dashboard-host.component";
// [duNumber] — the Qlik-style count the static dashboards' KPI figures animate
// with. Shared by DPM-Static and DEM-Static, so it lives at dashboard/static/
// rather than inside either of them.
import { AnimatedNumberDirective } from "./static/animated-number.directive";
import { OverlayModule } from "@angular/cdk/overlay";
// Powers the EMD filter bar's badge dropdowns, matching the filter-badges
// widget. Module imports are not transitive, so importing WidgetModule (which
// also uses CdkMenuModule) is not enough here.
import { CdkMenuModule } from "@angular/cdk/menu";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { SharedComponentModule } from "../shared/shared.module";
import { ChartsModule } from "../shared/charts/charts.module";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';
import { UserMenuComponent } from "./user-menu/user-menu.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { TruncatePipe } from "src/app/pipe/dot-truncate";
import { MatTabsModule } from "@angular/material/tabs";
import { WidgetDirective } from "../widget/widget.directive";
import { FilterButton } from "../widget/filter-button/filter-button";
import { MessengerModule } from "../messenger/messenger.module";
import { Gridster, GridsterItem } from "angular-gridster2";
import { TaskMgmtSidePanelComponent } from "./pages/task-mgmt-side-panel/task-mgmt-side-panel.component";
// Provides <app-global-case-sidebar> (and the subtask drilldown panel subtree)
// so the topnav can host the case sidebar globally. TaskPanelModule imports
// nothing from DirectModule, so this does not create a circular dependency.
import { TaskPanelModule } from "../direct/task-panel.module";
import { EmdDashboardComponent } from "./emd-dashboard/emd-dashboard.component";
import { EmdBarLineTrendChartComponent } from "./emd-dashboard/charts/emd-bar-line-trend-chart/emd-bar-line-trend-chart.component";
import { EmdBubbleMapChartComponent } from "./emd-dashboard/charts/emd-bubble-map-chart/emd-bubble-map-chart.component";
import { EmdChartStatesComponent } from "./emd-dashboard/charts/emd-chart-states.component";
import { EmdChartTooltipComponent } from "./emd-dashboard/charts/emd-chart-tooltip.component";
import { EmdDonutChartComponent } from "./emd-dashboard/charts/emd-donut-chart/emd-donut-chart.component";
import { EmdHierarchicalGridComponent } from "./emd-dashboard/charts/emd-hierarchical-grid/emd-hierarchical-grid.component";
import { EmdMultiLineTrendChartComponent } from "./emd-dashboard/charts/emd-multi-line-trend-chart/emd-multi-line-trend-chart.component";
import { EmdFilterBarComponent } from "./emd-dashboard/shared/emd-filter-bar.component";
import { EmdFilterPanelComponent } from "./emd-dashboard/shared/emd-filter-panel.component";
import { EmdSelectionToolbarComponent } from "./emd-dashboard/shared/emd-selection-toolbar.component";
import { EmdKpiCardComponent } from "./emd-dashboard/shared/emd-kpi-card.component";
import { EmdPillGroupComponent } from "./emd-dashboard/shared/emd-pill-group.component";
import { EmdToggleComponent } from "./emd-dashboard/shared/emd-toggle.component";
import { EmdWidgetHeaderComponent } from "./emd-dashboard/shared/emd-widget-header.component";
import { EmdDetailsTabComponent } from "./emd-dashboard/tabs/emd-details-tab.component";
import { EmdInventoryTabComponent } from "./emd-dashboard/tabs/emd-inventory-tab.component";
import { EmdSummaryTabComponent } from "./emd-dashboard/tabs/emd-summary-tab.component";
import { AppCustomDatepickerHeaderComponent } from "../shared/custom-input-type/timecycle-with-range/app-custom-datepicker-header";
// <app-progress-indefinite> — the same in-widget loading bar every dynamic
// widget shows while its query is in flight. DpmStaticComponent uses it so its
// panels load the way the real ones do.
import { ProgressIndefinite } from "../shared/progress-indicator/indefinite";
// <app-status-cell-info-dpm> — the Status Overview cell panel DpmStaticComponent
// renders inside its heat-tile hover tooltip. Standalone, and otherwise only
// pulled in by the widget's own standalone tooltip/modal, so this module has to
// import it as well. It must stay in this list: CUSTOM_ELEMENTS_SCHEMA below
// makes a missing import silent rather than an error — the tag renders as an
// empty inert element and the tooltip comes out blank, which is exactly how it
// failed before. The click popups were unaffected, because MatDialog builds
// those standalone components itself and never consults this module.
import { CellInfo as DpmCellInfo } from "../widget/status-overview/dpm/cell-info";
// <app-status-cell-info-dem> — the same thing for DemStaticComponent's heat-tile
// tooltip, and here for the same reason: standalone, otherwise only pulled in by
// the extract widget's own tooltip/modal, and silent when missing.
import { CellInfo as DemCellInfo } from "../widget/status-overview/dem/cell-info";
@NgModule({
  declarations: [
    WorkDisplayComponent,
    TopnavComponent,
    DashboardComponent,
    TruncatePipe,
    PagesComponent,
    TaskMgmtSidePanelComponent,
    EmdDashboardComponent,
    // EMD dashboard: shell, per-tab views and the presentational controls
    EmdFilterBarComponent,
    EmdFilterPanelComponent,
    EmdSelectionToolbarComponent,
    EmdPillGroupComponent,
    EmdToggleComponent,
    EmdWidgetHeaderComponent,
    EmdKpiCardComponent,
    EmdSummaryTabComponent,
    EmdDetailsTabComponent,
    EmdInventoryTabComponent,
    // EMD-owned charts. These must stay declared in this module: the ag-grid
    // Enterprise features the grid uses are registered by WidgetModule's
    // side-effect import, which this module already pulls in.
    EmdChartTooltipComponent,
    EmdChartStatesComponent,
    EmdBubbleMapChartComponent,
    EmdDonutChartComponent,
    EmdBarLineTrendChartComponent,
    EmdMultiLineTrendChartComponent,
    EmdHierarchicalGridComponent,
    DpmStaticComponent,
    DemStaticComponent,
    SqlCacheStaticComponent,
    VisitPlannerStaticComponent,
    // Market Access – Moonlake and its stacked-bar/waterfall chart. The chart
    // must stay declared: CUSTOM_ELEMENTS_SCHEMA would otherwise render the
    // <app-moonlake-waterfall-chart> tag as an empty element without an error.
    MarketAccessMoonlakeComponent,
    MoonlakeWaterfallChartComponent,
    MoonlakeSeriesChartComponent,
    // Must stay in this list, and the failure if it does not is a silent one:
    // CUSTOM_ELEMENTS_SCHEMA below turns an unmatched [duNumber] into a plain DOM
    // property set on a <div> instead of a build error, so the binding would do
    // nothing and — because the directive owns that element's text, with no
    // interpolation beside it — every KPI figure on both static screens would
    // render BLANK rather than un-animated. Same trap as the CellInfo imports
    // documented above.
    AnimatedNumberDirective,
    // Route target for ":module/static" (see DashboardRoutingModule). Being a
    // route component is not a declaration: left out of this list it compiles
    // as an orphan with an empty directive scope, so its own *ngIf silently
    // stops resolving and only fails in the browser (NG0303) — ngtsc merely
    // warns at build time.
    StaticDashboardHostComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule,
    ReactiveFormsModule,
    MatComponentsModule,
    AppLayoutModule,
    DashboardRoutingModule,
    NgMultiSelectDropDownModule,
    WidgetModule,
    MatDatepickerModule,
    OverlayModule,
    CdkMenuModule,
    MatExpansionModule,
    MatIconModule,
    SharedComponentModule,
    ChartsModule,
    MatAutocompleteModule,
    MatMenuModule,
    NgSelectModule,
    MatTabsModule,
    NgMultiSelectDropDownModule.forRoot(),
    WidgetDirective,
    FilterButton,
    MessengerModule,
    Gridster,
    GridsterItem,
    TaskPanelModule,
    AppCustomDatepickerHeaderComponent,
    ProgressIndefinite,
    DpmCellInfo,
    DemCellInfo
  ],
  exports: [
    DashboardRoutingModule,
    WorkDisplayComponent,
    TopnavComponent,
    WidgetModule,
    OverlayModule,
    PagesComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule {}
